import nodeClient from "./node-client";

export const saveDoctor = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/doctor/save`,
    payload
  );
  return response?.data?.result;
};

export const getDoctors = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/doctor/find/all`,
    payload
  );
  return response?.data?.result?.rows;
};

export const searchByDoctorName = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/doctor/search/by/name?${encodeURI(query)}`
  );
  return response.data.result;
};
export const fetchQualifications = async (query) => {
  const response = await nodeClient.post(
    `/service/protected/v0/profession/list?${query}`
  );
  return response.data.result;
};
export const saveProfession = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/profession/add`,
    payload
  );
  return response?.data?.result;
};

export const saveSpeciality = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/speciality/add`,
    payload
  );
  return response?.data?.result;
};

export const fetchAllSpeciality = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/speciality/findAll?${query}`
  );
  return response?.data?.result;
};
